<!--
    描述：签证对比首页
    时间：2020-12-3
    Created by yef
-->
<template>
    <w-split v-model="splitV"
             class="analysis-detail-main">
        <!-- 左侧结构树 -->
        <visa-structure slot="left"
                        :editable="false"
                        :showCheckbox="true"
                        ref="leftTree"
                        @onCheck="checkChange"></visa-structure>
        <!-- 右侧表格 -->
        <div class="w-strucutre-layout"
             slot="right">
            <div class="w-strucutre-header">
                <div class="btnGroups">
                    <el-tooltip effect="light" popper-class="help-content" append-to-body>
                        <div slot="content">
                            <p>
                                类似排序说明:
                            </p>
                            <p>
                                相同清单:项目编码前九位、清单名称、清单特征、计量单位一致;
                            </p>
                            <p>
                                类似清单:清单编码前六位一致，清单编码前九位、前六位不包括数字前面的字母
                            </p>
                        </div>
                        <span class="help-title"><i class="el-icon-question"></i> 帮助说明</span>
                    </el-tooltip>
                    <el-button size="small"
                               icon="el-icon-sort"
                               class="ml10"
                               @click="changeTableType">类似清单
                    </el-button>
                    <el-button size="small"
                               icon="el-icon-menu"
                               type="primary"
                               @click="doFilter">列过滤
                    </el-button>
                    <el-button size="small"
                               icon="el-icon-refresh"
                               type="warning"
                               @click="doReset">重置
                    </el-button>
                    <el-button plain
                               size="small"
                               type="primary"
                               icon="el-icon-download"
                               @click="doExport(0)">导出Excel
                    </el-button>
                    <el-button size="small"
                               icon="el-icon-upload"
                               v-if="roleBtns.includes('detail-Html')"
                               @click="doExport(1)">导出Html
                    </el-button>
                </div>
            </div>
            <div class="w-structure-content"
                 v-loading="sheetLoading">
                <visa-table ref="detailTable" :searchForm="exportObj"
                            @onSuccess="changeSelect"></visa-table>
            </div>
        </div>
    </w-split>
</template>

<script>
    // 组件
    import visaStructure from './visa_structure'
    import visaTable from './visa_table'
    import {getUnitsAndNames} from "@/api/modules/analysisDetail";

    // js
    import {mapState} from 'vuex'
    import { exportExcel, dateFormat } from '@/utils/tools'

    export default {
        components: {
            visaStructure,
            visaTable,
        },
        data() {
            return {
                splitV: 0.3,
                sheetLoading: false, // 列表等待状态
                tableData: [],
                showAllData: true, // 是否展示全部清单数据
                curName: '', // 当前点击的 结构树层级名称
                btnLoading: false,
                pageLoading: null,
                exportObj: {}
            }
        },
        methods: {
            // 左侧树复选框选择事件
            checkChange(arr) {
                if (this.$refs.detailTable) {
                    this.exportObj.treeIds = arr;
                    let params = this.setParams();
                    // 清空分析条件
                    params.analysisType = '0';
                    this.loadDetailTable(params);
                    // 获取名称和 编码数组
                    this.getCodeTypeList(params)
                }
            },

            // 请求传值参数设置
            setParams() {
                // 项目ID
                this.exportObj.projectId = this.curProjectId;
                this.exportObj.phase1 = this.$refs.detailTable.visaType1;
                this.exportObj.phase2 = this.$refs.detailTable.priceType2;
                return this.exportObj
            },

            // 加载表格
            loadDetailTable(params) {
                if (this.$refs.detailTable) {
                    // 请求参数
                    this.$refs.detailTable.queryParams = this.$utils.clone(params, true);
                    this.$refs.detailTable.loadData()
                }
            },

            // m弹窗关闭事件
            handleClose() {
                this.dialogObj.visible = false;
                this.btnLoading = false
            },

            // 点击列过滤按钮
            doFilter() {
                if (this.$refs.detailTable) {
                    this.$refs.detailTable.openFilter()
                }
            },

            // 切换表格展示（全部清单、异常清单）
            changeTableType() {
                this.showAllData = !this.showAllData;
                this.$refs.detailTable ? this.$refs.detailTable.changeData(this.showAllData) : ''
            },

            // 点击重置按钮
            doReset() {
                // 清除全部条件 （排序、筛选）
                if (this.$refs.detailTable) {
                    this.$refs.detailTable.clearAll()
                }
                // 重置时清空规则
                let params = this.setParams();
                this.loadDetailTable(params)
            },

            // 点击导出 （0 是excel, 1 是html）
            doExport(type) {
                if (
                    this.$refs.detailTable &&
                    this.$refs.detailTable.getListData().length === 0
                ) {
                    this.$message.info('暂时没有要导出的数据！')
                    return
                }
                let saveName = '签证数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
                let params = this.setParams()
                params.label = type
                params.saveName = saveName
                params.list = this.$refs.detailTable.getListData() || []
    
                exportExcel(
                    'visaDetailAnalysis/exportVisaData',
                    params,
                    saveName
                )
            },

            changeSelect() {
                this.showAllData = true;
            },

            // 获取编码分类数组
            getCodeTypeList(params) {
                getUnitsAndNames(params)
                    .then(res => {
                        if (this.$refs.detailTable) {
                            //  左侧清单名称过滤数组
                            this.$refs.detailTable.filterObj.names1 = res.data.names1;
                            //  左侧计量单位过滤数组
                            this.$refs.detailTable.filterObj.units1 = res.data.units1;
                            //  右侧清单名称过滤数组
                            this.$refs.detailTable.filterObj.names2 = res.data.names2;
                            //  右侧计量单位过滤数组
                            this.$refs.detailTable.filterObj.units2 = res.data.units2
                        }
                    })
                    .catch(err => {
                    })
            },
        },
        computed: {
            // 项目名称
            projectName() {
                return this.$route.query.projectName
            },
            // 项目ID
            curProjectId() {
                return this.$route.query.projectId
            },
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            }),
            // 用户名称
            ...mapState('user', {
                userName: state => state.userInfo.sname
            })
        },
    };
</script>

<style scoped lang="less">
    .analysis-detail-main {
        .check-row {
            margin-bottom: 7px;
            background-color: #a3e3ff;
            height: 35px;
            line-height: 35px;
            font-weight: 700;
            color: #333;

            .check-name {
                border-right: 1px solid #1d7f8a;
            }

            .check-content {
                text-align: left;
                padding-left: 15px;
            }
        }

        .check-row:nth-of-type(2) {
            background-color: #f5f5ad;
        }

        .check-row:nth-of-type(3) {
            background-color: #ffe4c4;
        }

        .check-row:nth-of-type(4) {
            background-color: #7fffd4;
        }

        .range-header {
            text-align: left;
            padding-left: 10px;
            height: 35px;
            line-height: 35px;
        }

        .range-content {
            padding: 10px;

            .range-row {
                display: flex;
                height: 40px;
                line-height: 40px;
                margin-bottom: 10px;
            }

            .range-row-name {
                display: flex;
                align-items: center;
                width: 100px;
            }

            .range-row-input {
                flex: 1;
                text-align: left;
            }
        }

        .help-title {
            color: #409eff;
            font-size: 14px;
            display: inline-block;
            line-height: 32px;
            margin: 0 15px;
            cursor: pointer;
        }
    }
</style>